var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 32,
    viewBox: "0 0 140 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4335_121069",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 140,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 139.2,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4335_121069)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2187 13.5866C22.506 13.5866 23.8514 14.9319 23.7977 16.9232H16.1287C16.5862 14.8243 18.093 13.5866 20.2187 13.5866ZM20.6494 23.1929C18.1198 23.1929 16.2364 21.4438 15.9942 18.9682H25.9503C27.0536 14.5822 24.6049 11.2993 20.2187 11.2993C16.5054 11.2993 13.4648 14.5014 13.4648 18.4301C13.4648 22.4933 16.5593 25.5609 20.6494 25.5609C23.7439 25.5609 26.1116 23.9731 27.1882 21.5514L25.1161 20.2599C24.4703 22.0089 22.9097 23.1929 20.6494 23.1929Z",
    fill: "#2722FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9037 11.2993C34.1007 11.2993 32.5938 12.1335 31.5174 13.2906V11.703H29.0957V25.1572H31.5174V18.0802C31.5174 15.7123 33.132 13.6673 35.769 13.6673C37.9755 13.6673 39.2941 15.0665 39.2941 17.0846V25.1572H41.7157V16.8694C41.7157 13.2906 39.4824 11.2993 35.9037 11.2993Z",
    fill: "#2722FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.8849 13.5865C66.1721 13.5865 67.5175 14.9319 67.4638 16.9232H59.7948C60.2522 14.8243 61.7592 13.5865 63.8849 13.5865ZM64.3154 25.5609C67.4099 25.5609 69.778 23.9731 70.8538 21.5514L68.7821 20.2598C68.1364 22.0088 66.5757 23.1929 64.3154 23.1929C61.786 23.1929 59.9024 21.4438 59.6602 18.9682H69.616C70.7196 14.5822 68.2709 11.2993 63.8849 11.2993C60.1715 11.2993 57.1309 14.5013 57.1309 18.43C57.1309 22.4932 60.2253 25.5609 64.3154 25.5609Z",
    fill: "#2722FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5548 13.6085C51.1157 13.6085 52.461 14.0121 53.9949 15.2229L54.0663 14.9915L55.3557 11.4626L53.3662 10.813L53.0027 12.2469C52.0239 11.7349 50.8506 11.3213 49.5818 11.3213C46.326 11.3213 44.523 12.828 44.523 15.0883C44.523 17.3218 46.4873 18.425 49.5279 19.3937C52.0036 20.1471 52.7032 20.8737 52.7032 21.5733C52.7032 22.7035 51.5999 23.3493 50.0393 23.3493C48.0212 23.3493 46.299 22.3268 45.3841 20.7661L43.5273 22.2998C44.6575 24.1296 46.9179 25.5828 49.9316 25.5828C53.4836 25.5828 55.2057 23.6991 55.2057 21.3312C55.2057 19.7705 54.1562 18.4788 50.1468 17.1604C48.3441 16.5414 47.0255 16.1917 47.0255 15.0346C47.0255 14.2004 47.5905 13.6085 49.5548 13.6085Z",
    fill: "#2722FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.0275 13.6007C7.58823 13.6007 8.93363 14.0043 10.4675 15.2151L10.539 14.9838L11.8284 11.4547L9.8389 10.8052L9.47526 12.2391C8.49654 11.7271 7.32326 11.3135 6.05444 11.3135C2.79863 11.3135 0.995704 12.8203 0.995704 15.0806C0.995704 17.314 2.96 18.4172 6.00056 19.3859C8.47627 20.1394 9.17582 20.8659 9.17582 21.5655C9.17582 22.6957 8.07253 23.3415 6.51197 23.3415C4.4938 23.3415 2.77169 22.319 1.8568 20.7583L0 22.292C1.13014 24.1218 3.39042 25.575 6.4043 25.575C9.95627 25.575 11.6784 23.6913 11.6784 21.3234C11.6784 19.7627 10.6289 18.4711 6.61947 17.1526C4.8168 16.5337 3.49818 16.1839 3.49818 15.0268C3.49818 14.1926 4.0632 13.6007 6.0275 13.6007Z",
    fill: "#2722FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.5801 18.4482C89.5801 15.6686 87.7446 13.6716 85.2075 13.6716C82.6712 13.6716 80.8357 15.6686 80.8357 18.4482C80.8357 21.228 82.6712 23.2249 85.2075 23.2249C87.7446 23.2249 89.5801 21.228 89.5801 18.4482ZM92.1163 18.4482C92.1163 22.5233 89.2015 25.5999 85.3157 25.5999C83.5885 25.5999 82.077 24.8442 80.9171 23.6838V25.195H78.4883V6.40918H80.9171V13.2128C82.077 12.0523 83.5885 11.2967 85.3157 11.2967C89.2015 11.2967 92.1163 14.3732 92.1163 18.4482Z",
    fill: "#2722FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.407 23.2123C97.8922 23.2123 96.0732 21.2326 96.0732 18.4771C96.0732 15.7217 97.8922 13.7421 100.407 13.7421C102.921 13.7421 104.74 15.7217 104.74 18.4771C104.74 21.2326 102.921 23.2123 100.407 23.2123ZM107.342 22.7557C107.241 22.7557 107.149 22.7404 107.068 22.7118C106.803 22.6188 106.646 22.381 106.646 22.033L106.944 18.4726L107.068 17.225L107.608 11.6939H105.199L105.016 13.7614C105.014 13.7592 105.012 13.7569 105.012 13.7547C104.999 13.7348 104.986 13.715 104.973 13.6954C104.8 13.4408 104.593 13.212 104.365 13.0071C103.258 12.0168 101.869 11.3879 100.3 11.3879C96.4474 11.3879 93.5586 14.4377 93.5586 18.4771C93.5586 22.5167 96.4474 25.5664 100.3 25.5664C101.982 25.5664 103.457 24.8433 104.599 23.7271C104.62 23.8943 104.637 23.9629 104.685 24.0871C104.693 24.1071 104.695 24.1128 104.695 24.1123C104.824 24.3661 104.987 24.577 105.206 24.7416C105.473 24.9418 105.805 25.0736 106.197 25.1314C106.346 25.1534 106.505 25.165 106.673 25.165H107.958V22.7557H107.342Z",
    fill: "#2722FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.315 11.2993C115.513 11.2993 114.006 12.1335 112.93 13.2906V11.703H110.508V25.1572H112.93V18.0802C112.93 15.7123 114.543 13.6673 117.181 13.6673C119.387 13.6673 120.706 15.0665 120.706 17.0846V25.1572H123.128V16.8694C123.128 13.2906 120.894 11.2993 117.315 11.2993Z",
    fill: "#2722FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.751 18.2104L137.717 11.7017H134.543L128.358 17.5111V6.3999H125.938V25.1492H128.358V19.2323L134.92 25.1492H138.443L130.751 18.2104Z",
    fill: "#2722FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.4605537128c920994e9f419c07282f68.svg";
export { ForwardRef as ReactComponent };